@if (leadStatus !== approvedStatus && !(entry === 'referral' && leadStatus === 'Review Complete') && showUpload) {
  <div class="ppl-mt20">
    @if(!readonly){
    <nz-form-item class="ppl-form-item pt-2">
      <nz-form-control class="ppl-form-control" [nzXs]="24">
        <p style="font-size:0.929rem;">{{message}}</p>
        <ppl-upload (filesUploaded)="filesUploaded($event)" [fileList]="fileList" [flow]="entry" [leadId]="leadId"
          [docTypeList]="licences" [showFileList]="false"></ppl-upload>
          <div class="ppl-form-item" *ngIf="fileListInfo?.length">
          </div>
      </nz-form-control>
    </nz-form-item>
    }
  </div>
  }
   <div class="btn-group mt-3 mb-2 d-flex justify-content-start">
      <div class="mr-3">
        <ppl-button *ngIf="isAckSupported && canAcknowledge" ariaLabel="Acknowledge" label="Acknowledge" icon="fa fa-check"
          [iconPosition]="'left'" [customClass]="'ghost-button'" [disabled]="!canAckSelected"
          (click)="onAcknowledgeClicked()">
        </ppl-button>
      </div>
    </div>
  @if(entry === 'provider' && filedInfo?.providerDocumentDetails.length > 0){
  @if(isMobileView) {
  <div class="card-layout">
    <div class="card" *ngFor="let file of fileListInfo">
      <div class="card-item mt-2">
        <strong>{{ file.fileName }}</strong>
      </div>
      <div class="card-item">
        {{ file.lkpValueName }}
      </div>
      <div class="btn-group mt-3 mb-2 d-flex justify-content-end">
        <div class="mr-3">
          <ppl-button ariaLabel="Download" label="Download" icon="fa fa-download" [customClass]="'ghost-button'"
            [iconPosition]="'left'" (click)="action({data: file, action: 'download'})"></ppl-button>
        </div>

        <ppl-button ariaLabel="Delete" label="Delete" icon="fa fa-trash" [customClass]="'ghost-button'"
          [iconPosition]="'left'" (click)="action({data: file, action: 'delete'})"></ppl-button>
      </div>
    </div>
  </div>
  } @else {
  <ppl-list-table [disableSort]="true" [disableSearch]="true" [tableWidth]="tableWidth"
      [enableActions]="showButtons && !readonly" [data]="fileListInfo" [disableSelection]="true"
      (selectionChanged)="onSelectionChange($event)" [cols]="cols" [gridTitle]="false" [pagination]="false"
      [loadPage]="true" (gridAction)="action($event)" [actionButtons]="actionButtons" [selectionDisabler]="isAcked">
    </ppl-list-table>

  }
  }
  @else if (entry === 'referral' && filedInfo?.referralDocumentDetails.length > 0) {
   <ppl-list-table [disableSort]="true" [disableSearch]="true" [tableWidth]="tableWidth"
      [enableActions]="showButtons && !readonly" [data]="fileListInfo" [disableSelection]="true"
      (selectionChanged)="onSelectionChange($event)" [cols]="cols" [gridTitle]="false" [pagination]="false"
      [loadPage]="true" (gridAction)="action($event)" [actionButtons]="actionButtons" [selectionDisabler]="isAcked">
    </ppl-list-table>
  
  }
  @else if (entry === 'participantEnrollment' && filedInfo?.participantEnrlDocumentDetails?.length > 0) {
  @if(isMobileView) {
  <div class="card-layout">
    <div class="card" *ngFor="let file of fileListInfo">
      <div class="card-item mt-2">
        <strong>{{ file.fileName }}</strong>
      </div>
      <div class="card-item">
        {{ file.lkpValueName }}
      </div>
      <div class="btn-group mt-3 mb-2 d-flex justify-content-end">
        @if(isPreviewable(file.fileType)){
        <div class="mr-3">
          <ppl-button ariaLabel="View" label="View" icon="fa fa-eye" [customClass]="'ghost-button'"
            [iconPosition]="'left'" (click)="action({data: file, action: 'view'})"></ppl-button>
        </div>
        }

        <div class="mr-3">
          <ppl-button ariaLabel="Download" label="Download" icon="fa fa-download" [customClass]="'ghost-button'"
            [iconPosition]="'left'" (click)="action({data: file, action: 'download'})"></ppl-button>
        </div>

        <ppl-button ariaLabel="Delete" label="Delete" icon="fa fa-trash" [customClass]="'ghost-button'"
          [iconPosition]="'left'" (click)="action({data: file, action: 'delete'})"></ppl-button>
      </div>
    </div>
  </div>
  } @else {
  <ppl-list-table [disableSort]="true" [disableSearch]="true" [tableWidth]="tableWidth"
      [enableActions]="showButtons && !readonly" [data]="fileListInfo" [disableSelection]="!isAckSupported"
      (selectionChanged)="onSelectionChange($event)" [cols]="cols" [gridTitle]="false" [pagination]="false"
      [loadPage]="true" (gridAction)="action($event)" [actionButtons]="actionButtons" [selectionDisabler]="isAcked">
    </ppl-list-table>

  }
  }
  @else if (entry === 'providerEnrollment' && filedInfo?.providerEnrlDocumentDetails?.length > 0) {
  @if(isMobileView) {
  <div class="card-layout">
    <div class="card" *ngFor="let file of fileListInfo">
      <div class="card-item mt-2">
        <strong>{{ file.fileName }}</strong>
      </div>
      <div class="card-item">
        {{ file.lkpValueName }}
      </div>
      <div class="btn-group mt-3 mb-2 d-flex justify-content-end">
        @if(isPreviewable(file.fileType)){
        <div class="mr-3">
          <ppl-button ariaLabel="View" label="View" icon="fa fa-eye" [customClass]="'ghost-button'"
            [iconPosition]="'left'" (click)="action({data: file, action: 'view'})"></ppl-button>
        </div>
        }

        <div class="mr-3">
          <ppl-button ariaLabel="Download" label="Download" icon="fa fa-download" [customClass]="'ghost-button'"
            [iconPosition]="'left'" (click)="action({data: file, action: 'download'})"></ppl-button>
        </div>

        <ppl-button ariaLabel="Delete" label="Delete" icon="fa fa-trash" [customClass]="'ghost-button'"
          [iconPosition]="'left'" (click)="action({data: file, action: 'delete'})"></ppl-button>
      </div>
    </div>
  </div>
  } @else {
  <ppl-list-table [disableSort]="true" [disableSearch]="true" [tableWidth]="tableWidth"
      [enableActions]="showButtons && !readonly" [data]="fileListInfo" [disableSelection]="!isAckSupported"
      (selectionChanged)="onSelectionChange($event)" [cols]="cols" [gridTitle]="false" [pagination]="false"
      [loadPage]="true" (gridAction)="action($event)" [actionButtons]="actionButtons" [selectionDisabler]="isAcked">
    </ppl-list-table>

  }
  }
  @else if (entry === 'auth' && filedInfo?.consumerAuthDocumentDetailsList?.length > 0) {
  <div class="auth-table-width">
    @if(isMobileView) {
    <div class="card-layout">
      <div class="card" *ngFor="let file of fileListInfo">
        <div class="card-item mt-2">
          <strong>{{ file.fileName }}</strong>
        </div>
        <div class="card-item">
          {{ file.lkpValueName }}
        </div>
        <div class="btn-group mt-3 mb-2 d-flex justify-content-end">
          <div class="mr-3">
            <ppl-button ariaLabel="Download" label="Download" icon="fa fa-download" [customClass]="'ghost-button'"
              [iconPosition]="'left'" (click)="action({data: file, action: 'download'})"></ppl-button>
          </div>
  
          <ppl-button ariaLabel="Delete" label="Delete" icon="fa fa-trash" [customClass]="'ghost-button'"
            [iconPosition]="'left'" (click)="action({data: file, action: 'delete'})"></ppl-button>
        </div>
      </div>
    </div>
    } @else {
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [tableWidth]="tableWidth"
        [enableActions]="showButtons && !readonly" [data]="fileListInfo" [disableSelection]="true"
        (selectionChanged)="onSelectionChange($event)" [cols]="cols" [gridTitle]="false" [pagination]="false"
        [loadPage]="true" (gridAction)="action($event)" [actionButtons]="actionButtons" [selectionDisabler]="isAcked">
      </ppl-list-table>
    }
  </div>
  }
  @else if (summary){
  <nz-row>
    <p tabindex="0">No Files Uploaded</p>
  </nz-row>
  }
  
  <div class="filter-panel">
    <ng-template #fileEditDialog let-cancel="cancel">
      <form [formGroup]="uploadForm">
      <nz-form-control nz-tooltip nzTooltipPlacement="topRight">
        <div [ngClass]="{'error': validationErrors['document_type'] }">
          <ppl-dropdown-select formControlName="document_type" id="document_type" pplNzAriaLabel
          arialabel="Document type"
          [options]="licences" [optionLabel]="'lkpValueName'"
          [optionValue]="'lkpValueCode'"
          placeholder="Select document type"
          (selectionChange)="docTypeChanged($event)"></ppl-dropdown-select>
      </div>
        @if(uploadForm.get('document_type')?.value === 'OTH'){
        <nz-form-item class="ppl-form-item" style="margin-top: 4px;">
          <nz-form-control class="">
            <div nz-tooltip nzTooltipPlacement="topRight">
              <input class="type-input" nz-input placeholder="Document Name" formControlName="other_type" />
            </div>
          </nz-form-control>
        </nz-form-item>
        }
        @if (validationErrors['document_type']) {
        <span class="pl-1 error-message">{{validationErrors['document_type']}}</span>
        }
      </nz-form-control>
    </form>
    </ng-template>

    <ng-template #documentDialog let-cancel="cancel">
      @if(previewKind === 'pdf'){
      <div class="">
        <ngx-extended-pdf-viewer [src]="previewSrc" [showToolbar]="false" useBrowserLocale="true" height="90vh">
        </ngx-extended-pdf-viewer>
      </div>
      }
      @else if(previewKind === 'image'){
      <div class="text-center">
        <img [src]="previewSrc" style="max-width: 100%; max-height: 85vh;" alt="Document preview" />
      </div>
      }
      @else if(previewKind === 'text'){
      <pre class="text-preview">{{ previewText }}</pre>
      }
    </ng-template>
  </div>

<ppl-popup-dialog [(isVisible)]="showDeleteConfirmation" [title]="'Delete Document'" [isOkText]="'Ok'"
  (cancel)="onDeleteDialogClose()" [showButtons]="true" [position]="'top'" size="medium" (confirm)="handleConfirmDelete()">
  <div>
    <p>Are you sure you want to delete this document?</p>
  </div>
</ppl-popup-dialog>